export enum StrapiTeaserElementTypes {
    VARIANTS = 'variants',
    INSTANCES = 'instances'
}